module.exports = __webpack_public_path__ + "img/phone-heading-img.88449473.png";